import { IconNames } from "@alternative/icons";
import React, { useState, useEffect } from "react";
import { Icon } from "../../atoms";
export const EDIT_ACTIONS = {
  DOUBLE_CLICK: "DOUBLE_CLICK",
  SINGLE_CLICK: "SINGLE_CLICK",
};
export const Editable = ({
  text,
  type = "input",
  placeholder,
  children,
  childRef,
  showIcon = true,
  disabled,
  editAction = EDIT_ACTIONS.DOUBLE_CLICK,
  ...props
}) => {
  const [isEditing, setEditing] = useState(false);

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  const handleKeyDown = (event, type) => {
    const { key } = event;
    const keys = ["Escape", "Tab"];
    const enterKey = "Enter";
    const allKeys = [...keys, enterKey];
    if ((type === "textarea" && keys.indexOf(key) > -1) || (type !== "textarea" && allKeys.indexOf(key) > -1)) {
      setEditing(false);
    }
  };

  return (
    <section {...props}>
      {isEditing ? (
        <div className="at-editable" onBlur={() => setEditing(false)} onKeyDown={(e) => handleKeyDown(e, type)}>
          {children}
        </div>
      ) : (
        <div
          className={`at-editable`}
          onDoubleClick={() => {
            if (disabled || editAction !== EDIT_ACTIONS.DOUBLE_CLICK) return;
            setEditing(true);
          }}
          onClick={() => {
            if (disabled || editAction !== EDIT_ACTIONS.SINGLE_CLICK) return;
            setEditing(true);
          }}
        >
          {text}
          {showIcon && <Icon icon={IconNames.EDIT} />}
        </div>
      )}
    </section>
  );
};
